import { CustomLoggerService } from './service/custom-logger.service';
import { CurrencyService } from './modules/shared/services/currency.service';
import { DashboardDataService } from './profile/dashboard/services/dashboard-data.service';
import { ActivityService } from "./shared/shared-activities/activity.service";
import {
    APP_INITIALIZER,
    CUSTOM_ELEMENTS_SCHEMA,
    NgModule,
    NO_ERRORS_SCHEMA,
} from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
    LocationStrategy,
    PathLocationStrategy,
} from "@angular/common";
import { AppRoutingModule } from "./app-routing.module";
import { DragDropModule } from "@angular/cdk/drag-drop";
// import { GMapModule } from "primeng/gmap";
import { NgxChartsModule } from "@swimlane/ngx-charts";

import { AccordionModule } from "primeng/accordion";
import { AutoCompleteModule } from "primeng/autocomplete";
import { BreadcrumbModule } from "primeng/breadcrumb";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { CarouselModule } from "primeng/carousel";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { ChipsModule } from "primeng/chips";
// import { CodeHighlighterModule } from "primeng/codehighlighter";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { ColorPickerModule } from "primeng/colorpicker";
import { ContextMenuModule } from "primeng/contextmenu";
import { DataViewModule } from "primeng/dataview";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { FieldsetModule } from "primeng/fieldset";
import { FileUploadModule } from "primeng/fileupload";
import { FullCalendarModule } from '@fullcalendar/angular';
import { GalleriaModule } from "primeng/galleria";
import { InplaceModule } from "primeng/inplace";
import { InputNumberModule } from "primeng/inputnumber";
import { InputMaskModule } from "primeng/inputmask";
import { InputSwitchModule } from "primeng/inputswitch";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { EditorModule } from "primeng/editor";
// import { LightboxModule } from "primeng/lightbox";
import { ListboxModule } from "primeng/listbox";
import { MegaMenuModule } from "primeng/megamenu";
import { MenuModule } from "primeng/menu";
import { MenubarModule } from "primeng/menubar";
import { MessagesModule } from "primeng/messages";
import { MessageModule } from "primeng/message";
import { MultiSelectModule } from "primeng/multiselect";
import { OrderListModule } from "primeng/orderlist";
import { OrganizationChartModule } from "primeng/organizationchart";
import { OverlayPanelModule } from "primeng/overlaypanel";
import { PaginatorModule } from "primeng/paginator";
import { PanelModule } from "primeng/panel";
import { PanelMenuModule } from "primeng/panelmenu";
import { PasswordModule } from "primeng/password";
import { PickListModule } from "primeng/picklist";
import { ProgressBarModule } from "primeng/progressbar";
import { RadioButtonModule } from "primeng/radiobutton";
import { RatingModule } from "primeng/rating";
import { RippleModule } from "primeng/ripple";
import { ScrollPanelModule } from "primeng/scrollpanel";
import { SelectButtonModule } from "primeng/selectbutton";
import { SidebarModule } from "primeng/sidebar";
import { SlideMenuModule } from "primeng/slidemenu";
import { SliderModule } from "primeng/slider";
import { SplitButtonModule } from "primeng/splitbutton";
import { StepsModule } from "primeng/steps";
import { TabMenuModule } from "primeng/tabmenu";
import { TableModule, } from "primeng/table";
import { TabViewModule } from "primeng/tabview";
import { TerminalModule } from "primeng/terminal";
import { TieredMenuModule } from "primeng/tieredmenu";
import { ToastModule } from "primeng/toast";
import { ToggleButtonModule } from "primeng/togglebutton";
import { ToolbarModule } from "primeng/toolbar";
import { TooltipModule } from "primeng/tooltip";
import { TreeModule } from "primeng/tree";
import { TreeTableModule } from "primeng/treetable";
import { VirtualScrollerModule } from "primeng/virtualscroller";
import { BlockUIModule } from "primeng/blockui";
import { ProgressSpinnerModule } from "primeng/progressspinner";
import { DividerModule } from 'primeng/divider';
import { JwtModule } from "@auth0/angular-jwt";
import { SplitterModule } from 'primeng/splitter';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { ImageModule } from 'primeng/image';
import { CodeInputModule } from 'angular-code-input';

// Application Components
import { AppCodeModule } from "./app.code.component";
import { AppComponent } from "./app.component";
import { AppMainComponent } from "./app.main.component";
import { AppConfigComponent } from "./app.config.component";
import { AppMenuComponent } from "./app.menu.component";
import { AppMenuitemComponent } from "./app.menuitem.component";
import { AppTopBarComponent } from "./app.topbar.component";
import { AppFooterComponent } from "./app.footer.component";

//Pages
import { AppNotfoundComponent } from "./pages/app.notfound.component";
import { AppErrorComponent } from "./pages/app.error.component";
import { AppAccessdeniedComponent } from "./pages/app.accessdenied.component";

// Application services
import { MenuService } from "./app.menu.service";
import { CasesService } from "./cases/cases.service";
import { ImportService } from "./modules/shared/components/import/import.service";
import { AppMainService } from "./app-main.service";
import { SharedSystemActivitiesService } from "./shared/shared-system-activities/shared-system-activities.service";

// LionO360
import { UserService } from './service/userservice';
import { Widget1Component } from './widgets/charts/widget1/widget1.component';
import { Widget2Component } from './widgets/charts/widget2/widget2.component';
import { Widget3Component } from './widgets/charts/widget3/widget3.component';
import { Widget5Component } from './widgets/charts/widget5/widget5.component';
import { Widget6Component } from './widgets/charts/widget6/widget6.component';
import { Widget7Component } from './widgets/charts/widget7/widget7.component';
import { Widget8Component } from './widgets/charts/widget8/widget8.component';
import { Widget9Component } from './widgets/charts/widget9/widget9.component';
import { Widget10Component } from './widgets/charts/widget10/widget10.component';
import { Widget11Component } from './widgets/charts/widget11/widget11.component';
import { Widget12Component } from './widgets/charts/widget12/widget12.component';
import { Widget13Component } from './widgets/dataTable/widget13/widget13.component';
import { Widget14Component } from './widgets/dataTable/widget14/widget14.component';
import { Widget15Component } from './widgets/dataTable/widget15/widget15.component';
import { Widget16Component } from './widgets/dataTable/widget16/widget16.component';
import { Widget17Component } from './widgets/dataTable/widget17/widget17.component';
import { Widget18Component } from './widgets/dataTable/widget18/widget18.component';
import { Widget19Component } from './widgets/dataTable/widget19/widget19.component';
import { Widget20Component } from './widgets/dataTable/widget20/widget20.component';
import { Widget21Component } from './widgets/dataTable/widget21/widget21.component';
import { Widget22Component } from './widgets/dataTable/widget22/widget22.component';
import { Widget23Component } from './widgets/dataTable/widget23/widget23.component';
import { Widget24Component } from './widgets/dataTable/widget24/widget24.component';
import { GridsterModule } from 'angular-gridster2';
import { AccountService } from './accounts/accountService';
import { InventoryComponent } from './inventory/inventory.component';
import { MoreComponent } from './more/more.component';
import { LeadService } from './leads/leadService';
import { ConfigurationService } from './configurations/configurationService';
import { OpportunityService } from './opportunities/opportunity.service';
import { ContactService } from './contacts/contactService';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { ConfirmationService, MessageService } from "primeng/api";
import { TerriService } from "./more/territory/services/terriService";
import { GoalsComponent } from "./more/goals/goals.component";
import { GoalsService } from "./more/goals/goalsService";
import { GlobalFilter } from "./service/filter.pipe";
import { EmailService } from "./shared/shared-emails/email.service";
import { PdfService } from "./service/pdf.service";
import { PermissionService } from "./service/permission.service";
import { OpportunitiesGuardService } from "./opportunities/opportunities.guard.service";
import { GoalGuardService } from "./more/goals/gaols.guard.service";
import { CompanyBranchService } from "./configurations/company-branch/company-branch.service";


import {
    VendorOAuthRegistrationUserService,
    CategoryService,
    VendorOAuthRegistrationService,
    VendorService,
} from "./shared/shared-emails/Integration/api/api";
import {
    LogService,
    NoteService,
    ObjectEmailAuditService,
    ObjectCalendarEventService,
    ObjectTaskService,
    RepeatTypeService,
    GroupService,
    TypeService,
    EmailAuditService,
    TaskService,
    TaskCategoryService,
    CalendarEventService,
    RecipientTypeService,
    ObjectLogService,
    ObjectNoteService,
    LocationService,
} from "./shared/api/api";
import { TypeService as SharedTypeService } from './shared/shared-emails/api/api';
import { LayoutModule } from '@angular/cdk/layout';
import { DatePipe, TitleCasePipe, DecimalPipe } from '@angular/common';
import { AttachmentChipsComponent } from './shared/attachment-chips/attachment-chips.component';
import {
    ReportService,
} from "./reports/reportService";
import { ContactService as contactService } from "./shared/shared-contacts/api/api";
import { AccountUserService } from "./service/account.service";
import { TokenInterceptor } from "./token-interceptor/token.interceptor";
import { QuotationComponent } from "./inventory/quotation/quotation.component";
import { QuotationService } from "./inventory/quotation/quotation.service";
import { SalesOrderService } from "./inventory/sales-order/sales-order.service";
import { ProductsService } from "./inventory/products/products.service";
import { FinanceService } from "./finance/finance.service";
import { QuestionnaireService } from "./more/questionnaire/questionnaire.service";
import { NotificationsComponent } from "./notifications/notifications.component";
import { NotificationService } from "./notifications/notificationService";

import { MentionModule } from "angular-mentions";
import { ProfileService } from "./profile/profileService";
import { OrderrByPipe } from './shared/pipes/order-by.pipe';

import { TranslocoModule } from "@ngneat/transloco";
import { TranslocoRootModule } from "./transloco/transloco-root.module";
import { ForgotPasswordComponent } from "./forgot-password/forgot-password.component";
import { ProductComponent } from "./configurations/inventory/product/product.component";
import { TypeComponent } from "./configurations/inventory/product/type/type.component";
import { TemplateComponent } from "./configurations/inventory/product/template/template.component";
import { CategoryComponent } from "./configurations/inventory/product/category/category.component";
import { FieldsComponent } from "./configurations/inventory/product/fields/fields.component";
import { ProductVisibilityComponent } from "./configurations/inventory/product/visibility/visibility.component";
import { ProductTagsComponent } from "./configurations/inventory/product/tags/tags.component";

import { TreeSelectComponent } from "./shared/p-treeselect/p-treeselect.component";
import { CompanyBranchComponent } from "./configurations/company-branch/company-branch.component";
import { SetupComponent } from "./configurations/inventory/setup/setup.component";
import { CustomComponent } from "./configurations/inventory/custom/custom.component";
import { PaymenttermComponent } from "./configurations/inventory/setup/paymentterm/paymentterm.component";
import { PaymentmethodComponent } from "./configurations/inventory/setup/paymentmethod/paymentmethod.component";
import { ShippingtermComponent } from "./configurations/inventory/setup/shippingterm/shippingterm.component";
import { ShippingmethodComponent } from "./configurations/inventory/setup/shippingmethod/shippingmethod.component";
import { FobpointComponent } from "./configurations/inventory/setup/fobpoint/fobpoint.component";
import { DiscountComponent } from "./configurations/inventory/setup/discount/discount.component";
import { AdditionlfeesComponent } from './configurations/inventory/setup/additionlfees/additionlfees.component';
import { TaxrateComponent } from "./configurations/inventory/setup/taxrate/taxrate.component";
import { OrdersourceComponent } from "./configurations/inventory/setup/ordersource/ordersource.component";
import { PricingComponent } from "./configurations/inventory/pricebook/pricing/pricing.component";
import { AddYearPipe } from "./shared/pipes/add-year.pipe";
import { NumbersOnlyDirective } from "./configurations/inventory/common/directives/numbers-only.directive";
import { DecimalNumbersDirective } from "./configurations/inventory/common/directives/decimal-numbers.directive";
import { ToLocalPipe } from "./service/to-local.pipe";
import { LocationComponent } from "./configurations/inventory/location/location.component";
import { BinsComponent } from "./configurations/inventory/location/bins/bins.component";
import { LocationFieldsComponent } from "./configurations/inventory/location/location-fields/location-fields.component";
import { ListComponent } from "./configurations/inventory/custom/list/list.component";
import { LocalDatePipe } from "./shared/pipes/local-date.pipe";
import { SectionComponent } from "./configurations/inventory/custom/section/section.component";
import { Uom1Component } from "./configurations/inventory/setup/uom1/uom1.component";
import { FinanceSetupComponent } from "./configurations/finance/finance-setup/finance-setup.component";
import { AccountComponent } from "./configurations/finance/finance-setup/account/account.component";
import { ClassComponent } from "./configurations/finance/finance-setup/class/class.component";
import { PurchaseComponent } from "./configurations/inventory/purchase/purchase.component";
import { PurchaseTypeComponent } from "./configurations/inventory/purchase/purchase-type/purchase-type.component";
import { PurchaseTemplateComponent } from "./configurations/inventory/purchase/purchase-template/purchase-template.component";
import { OrdersComponent } from "./configurations/inventory/orders/orders.component";
import { OrdersTypeComponent } from "./configurations/inventory/orders/orders-type/orders-type.component";
import { OrdersTemplateComponent } from "./configurations/inventory/orders/orders-template/orders-template.component";
import { OrdersStatusComponent } from "./configurations/inventory/orders/orders-status/orders-status.component";
import { PurchaseStatusComponent } from "./configurations/inventory/purchase/purchase-status/purchase-status.component";
import { PurchaseFieldsComponent } from "./configurations/inventory/purchase/purchase-fields/purchase-fields.component";
import { OrderFieldsComponent } from "./configurations/inventory/orders/order-fields/order-fields.component";
import { CustomersComponent } from "./configurations/inventory/customers/customers.component";
import { CustomersChannelComponent } from "./configurations/inventory/customers/customers-channel/customers-channel.component";
import { CustomersTemplateComponent } from "./configurations/inventory/customers/customers-template/customers-template.component";
import { CustomersFieldComponent } from "./configurations/inventory/customers/customers-field/customers-field.component";
import { CaseComponent } from "./configurations/crm/case/case.component";
import { ChannelComponent } from "./configurations/crm/case/channel/channel.component";
import { CaseFieldsComponent } from "./configurations/crm/case/fields/fields.component";
import { CaseTemplateComponent } from "./configurations/crm/case/template/template.component";
import { CaseFieldCategoryComponent } from "./configurations/crm/case/fields/category/category.component";
import { CrmCustomComponent } from "./configurations/crm/custom/custom.component";
import { CrmCustomFieldListComponent } from "./configurations/crm/custom/list/list.component";
import { CrmCustomSectionComponent } from "./configurations/crm/custom/section/section.component";

import { CrmAccountComponent } from "./configurations/crm/account/acccount.component";
import { CrmAccounChannelComponent } from "./configurations/crm/account/channel/channel.component";
import { CrmAccountTemplateComponent } from "./configurations/crm/account/template/template.component";
import { CrmAccountFieldsComponent } from "./configurations/crm/account/fields/fields.component";
import { NgIdleKeepaliveModule } from "@ng-idle/keepalive";

import { CrmLeadsComponent } from "./configurations/crm/leads/leads.component";
import { CrmLeadsChannelComponent } from "./configurations/crm/leads/channel/channel.component";
import { CrmLeadsFieldsComponent } from "./configurations/crm/leads/fields/fields.component";
import { CrmLeadsTemplateComponent } from "./configurations/crm/leads/template/template.component";
import { CrmOpportunityComponent, CrmOpportunityChannelComponent, CrmOpportunityTemplateComponent, CrmOpportunityFieldsComponent } from './configurations/crm/opportunity';

import { SharedComponentModule } from "./modules/shared/shared.module";
import { PrimngDesignModule } from "./modules/primng-design/primng-design.module";
import { AccountingComponent } from "./configurations/integration/accounting/accounting.component";
import { BotsComponent } from "./configurations/integration/bots/bots.component";
import { WhatsappSetupComponent } from './configurations/integration/bots/components/whatsapp-setup.component';
import { EmailComponent } from "./configurations/integration/email/email.component";
import { LeadGenerationComponent } from "./configurations/integration/lead-generation/lead-generation.component";
import { ProposalComponent } from "./configurations/integration/proposal/proposal.component";
import { EcommerceComponent } from "./configurations/integration/ecommerce/ecommerce.component";
import { CrmQuestionnaireComponent, CrmQuestionnaireQuestionsComponent, CrmQuestionnaireGroupsComponent } from './configurations/crm/questionnaire';
import { SystemNotificationComponent } from './configurations/system/notification';
import { TemplateComponent as emailTemplate } from './configurations/system/template/template.component';
import { CrmContactsComponent } from './configurations/crm/contacts';
import { CrmGoalComponent } from './configurations/crm/goal/goal.component';
import { CrmGoalByComponent } from './configurations/crm/goal/goal-by/goal-by.component';
import { ConfigUserPermissionComponent, ConfigurationUserComponent } from './configurations/users/user';
import { ConfigRolePermissionComponent, ConfigRoleComponent } from './configurations/users/role';
import { InventoryQuantityComponent } from './configurations/inventory/quantity';
import { DetailBlockComponent } from './shared/detail-block/detail-block.component';
import { OrderUpcomingTasksPipe } from "./shared/pipes/order-tasks.pipe";
import { OrderOtherActivitiesPipe } from "./shared/pipes/order-other-activities.pipe";
// For account module
import { ContactService as SharedContactService } from "./modules/shared/components/shared-contacts/api/contact.service";
import { CustomRuleComponent } from './configurations/inventory/custom-rule/custom-rule.component';
import { SmtpComponent } from './configurations/integration/smtp/smtp.component';
import { SmtpAddEditComponent } from './configurations/integration/smtp/add-edit/smtp-add-edit/smtp-add-edit.component';
import { ShippingComponent } from './configurations/integration/shipping/shipping.component';
import { PackBoxComponent } from './configurations/inventory/setup/pack-box/pack-box.component';
import { PricebookComponent } from './configurations/inventory/pricebook/pricebook.component';
import { AssignComponent } from './configurations/inventory/pricebook/assign/assign.component';
import { GroupComponent } from './configurations/inventory/pricebook/group/group.component';
import { SettingComponent } from './configurations/crm/account/setting/setting.component';
import { DiscountSelectComponent } from './configurations/inventory/pricebook/discount-select/discount-select.component';
import { ReportsModule } from "./reports/reports.module";
import { SavedSearchesModule } from './misc/saved-searches/saved-searches.module';
import { MassEditModule } from './misc/mass-edit/mass-edit.module';
import { FsmTerritoryComponent } from './configurations/fsm/territory/territory.component';
import { FsmTerritoryTypeComponent } from './configurations/fsm/territory/components/type/type.component';
import { FsmTerritoryActionComponent } from './configurations/fsm/territory/components/action/action.component';
import { GlobalSearchComponent } from './configurations/system/global-search/global-search-config.component';
import { SavedSearchComponent } from './configurations/system/saved-search/saved-search.component';
import { DuplicateCheckComponent } from './configurations/system/duplicate-check/duplicate-check.component';
import { SharedEmailToModuleRecordComponent } from './configurations/crm/shared/components/email-to-module-record/email-to-module-record.component';
import { TermsConditionsComponent } from './configurations/inventory/orders/terms-conditions/terms-conditions.component';
import { SignatureComponent } from './configurations/inventory/orders/signature/signature.component';
import { RoleHierarchyComponent } from './configurations/users/role-hierarchy/role-hierarchy.component';
import { ProfileComponent } from './configurations/users/profile/profile.component';
import { GuideComponent } from './guide/guide.component';
import { ISettingComponent } from './configurations/inventory/setting/setting.component';
import { CSettingComponent } from './configurations/crm/setting/setting.component';
import { FSettingComponent } from './configurations/fsm/setting/setting.component';

// Configuration New Shared Components
import { CrmSharedConfigurationComponent } from './configurations/crm/shared/components/crm-shared-configuration/crm-shared-configuration.component';
import { CrmSharedChannelComponent } from './configurations/crm/shared/components/crm-shared-channel/crm-shared-channel.component';
import { CrmSharedTemplateComponent } from './configurations/crm/shared/components/crm-shared-template/crm-shared-template.component';

// NgRx Store Modules
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { effects, reducers } from './modules/shared/stores/ngrx.imports';
import { clearStateMetaReducer } from './modules/shared/stores/logOut/logOut.reducer';
import { VisibilityGroupComponent } from './configurations/users/visibility-group/visibility-group.component';
import { SeriesComponent } from './configurations/system/series/series.component';
import { WorkflowModule } from './misc/workflow/workflow.module';
import { TemplateTableComponent } from './configurations/system/template/table/table.component';
import { EmailTemplateComponent } from './configurations/system/template/email-template/email-template.component';
import { PrintTemplateComponent } from './configurations/system/template/print-template/print-template.component';
import { CookieService } from 'ngx-cookie-service';
import { AddPhoneComponent } from './configurations/integration/bots/add-phone/add-phone.component';
import { appInitializerFactory } from './app-initializer.factory';
import { PickerModule } from '@ctrl/ngx-emoji-mart';
import { RegistrationComponent } from './configurations/integration/bots/registration/registration.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { PosComponent } from './configurations/integration/pos/pos.component';
import { SerialDetailsComponent } from './modules/shared/components/serial-details/serial-details.component';

import { InMemoryDataService } from './service/InMemoryDbService';
import { HttpClientInMemoryWebApiModule } from 'angular-in-memory-web-api';

import * as Sentry from "@sentry/angular";
import { FinanceModulePermissionService } from './finance/finance-module-permission.service';
import { ConfigurationWorkspaceComponent } from './configurations/misc/workspace/workspace.component';
import { WorkspaceCommentCategoryComponent } from './configurations/misc/workspace/workspace-comment-category/workspace-comment-category.component';
import { AddUpdateCommentCategoryComponent } from './configurations/misc/workspace/add-update-comment-category/add-update-comment-category.component';
import { ActivityComponent } from './configurations/system/activity/activity.component';

import { BaseChartDirective } from 'ng2-charts';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { ForgotOrganizationIDComponent } from './forgot-organization-id/forgot-organization-id.component';
import { ReportTableService } from './finance/report-table/report-table.service';

@NgModule({
    imports: [
        BrowserModule,
        LayoutModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        AccordionModule,
        AutoCompleteModule,
        BreadcrumbModule,
        ButtonModule,
        CalendarModule,
        CardModule,
        CarouselModule,
        ChartModule,
        CheckboxModule,
        NgIdleKeepaliveModule.forRoot(),
        ChipsModule,
        // CodeHighlighterModule,
        ConfirmDialogModule,
        ColorPickerModule,
        ContextMenuModule,
        DataViewModule,
        DialogModule,
        DropdownModule,
        FieldsetModule,
        FileUploadModule,
        FullCalendarModule,
        GalleriaModule,
        InplaceModule,
        InputNumberModule,
        InputMaskModule,
        InputSwitchModule,
        InputTextModule,
        InputTextareaModule,
        EditorModule,
        // LightboxModule,
        ListboxModule,
        MegaMenuModule,
        MenuModule,
        MenubarModule,
        MessageModule,
        MessagesModule,
        MultiSelectModule,
        OrderListModule,
        OrganizationChartModule,
        OverlayPanelModule,
        PaginatorModule,
        PanelModule,
        PanelMenuModule,
        PasswordModule,
        PickListModule,
        ProgressBarModule,
        RadioButtonModule,
        RatingModule,
        RippleModule,
        ScrollPanelModule,
        SelectButtonModule,
        SidebarModule,
        SlideMenuModule,
        SliderModule,
        SplitButtonModule,
        StepsModule,
        TableModule,
        TabMenuModule,
        TabViewModule,
        TerminalModule,
        TieredMenuModule,
        ToastModule,
        ToggleButtonModule,
        ToolbarModule,
        TooltipModule,
        TreeModule,
        TreeTableModule,
        VirtualScrollerModule,
        AppCodeModule,
        GridsterModule,
        SplitterModule,
        ImageModule,
        DragDropModule,
        // GMapModule,
        BlockUIModule,
        MentionModule,
        TranslocoRootModule,
        TranslocoModule,
        NgxChartsModule,
        ProgressSpinnerModule,
        DividerModule,
        PdfViewerModule,
        // Ng2PageScrollModule,
        PrimngDesignModule,
        SharedComponentModule,
        BaseChartDirective,
        JwtModule.forRoot({
            config: {
                tokenGetter: () => localStorage.getItem('access_token')
            }
        }),
        HttpClientInMemoryWebApiModule.forRoot(InMemoryDataService, {
            passThruUnknownUrl: true,
        }),
        ReportsModule,
        SavedSearchesModule,
        WorkflowModule,
        MassEditModule,
        StoreModule.forRoot(reducers, { metaReducers: [clearStateMetaReducer] }),
        EffectsModule.forRoot(effects),
        CodeInputModule,
        PickerModule
    ],
    declarations: [
        AppComponent,
        AppMainComponent,
        AppConfigComponent,
        AppMenuComponent,
        AppMenuitemComponent,
        AppTopBarComponent,
        AppFooterComponent,
        AppNotfoundComponent,
        AppErrorComponent,
        AppAccessdeniedComponent,
        Widget1Component,
        Widget2Component,
        Widget3Component,
        Widget5Component,
        Widget6Component,
        Widget7Component,
        Widget8Component,
        Widget9Component,
        Widget10Component,
        Widget11Component,
        Widget12Component,
        Widget13Component,
        Widget14Component,
        Widget15Component,
        Widget16Component,
        Widget17Component,
        Widget18Component,
        Widget19Component,
        Widget20Component,
        Widget21Component,
        Widget22Component,
        Widget23Component,
        Widget24Component,
        InventoryComponent,
        MoreComponent,
        ConfigurationsComponent,
        GoalsComponent,
        GoalsComponent,
        GlobalFilter,
        AttachmentChipsComponent,
        QuotationComponent,
        NotificationsComponent,
        OrderrByPipe,
        OrderUpcomingTasksPipe,
        OrderOtherActivitiesPipe,
        ForgotOrganizationIDComponent,
        ForgotPasswordComponent,
        ProductComponent,
        TypeComponent,
        ProductVisibilityComponent,
        TemplateComponent,
        CategoryComponent,
        FieldsComponent,
        ProductVisibilityComponent,
        ProductTagsComponent,
        TreeSelectComponent,
        CompanyBranchComponent,
        SetupComponent,
        CustomComponent,
        PaymenttermComponent,
        PaymentmethodComponent,
        ShippingtermComponent,
        ShippingmethodComponent,
        FobpointComponent,
        DiscountComponent,
        TaxrateComponent,
        OrdersourceComponent,
        PricingComponent,
        AddYearPipe,
        NumbersOnlyDirective,
        DecimalNumbersDirective,
        ToLocalPipe,
        LocationComponent,
        BinsComponent,
        LocationFieldsComponent,
        ListComponent,
        LocalDatePipe,
        SectionComponent,
        Uom1Component,
        FinanceSetupComponent,
        AccountComponent,
        ClassComponent,
        PurchaseComponent,
        PurchaseTypeComponent,
        PurchaseTemplateComponent,
        OrdersComponent,
        OrdersTypeComponent,
        OrdersTemplateComponent,
        OrdersStatusComponent,
        PurchaseStatusComponent,
        PurchaseFieldsComponent,
        OrderFieldsComponent,
        CaseComponent,
        CaseTemplateComponent,
        CaseFieldsComponent,
        ChannelComponent,
        CustomersComponent,
        CustomersChannelComponent,
        CustomersTemplateComponent,
        CustomersFieldComponent,
        CaseFieldCategoryComponent,
        CrmCustomComponent,
        CrmCustomFieldListComponent,
        CrmCustomSectionComponent,
        CrmAccountComponent,
        CrmAccounChannelComponent,
        CrmAccountTemplateComponent,
        CrmAccountFieldsComponent,
        CrmLeadsComponent,
        CrmLeadsChannelComponent,
        CrmLeadsFieldsComponent,
        CrmLeadsTemplateComponent,
        CrmOpportunityComponent,
        CrmOpportunityFieldsComponent,
        CrmOpportunityChannelComponent,
        CrmOpportunityTemplateComponent,
        AccountingComponent,
        BotsComponent,
        WhatsappSetupComponent,
        EmailComponent,
        LeadGenerationComponent,
        ProposalComponent,
        EcommerceComponent,
        CrmQuestionnaireComponent,
        CrmQuestionnaireGroupsComponent,
        CrmQuestionnaireQuestionsComponent,
        CrmGoalComponent,
        CrmGoalByComponent,
        SystemNotificationComponent,
        emailTemplate,
        CrmContactsComponent,
        ConfigUserPermissionComponent,
        ConfigurationUserComponent,
        ConfigRolePermissionComponent,
        ConfigRoleComponent,
        InventoryQuantityComponent,
        CustomRuleComponent,
        DetailBlockComponent,
        SmtpComponent,
        SmtpAddEditComponent,
        ShippingComponent,
        PackBoxComponent,
        PricebookComponent,
        AssignComponent,
        GroupComponent,
        SettingComponent,
        DiscountSelectComponent,
        FsmTerritoryComponent,
        FsmTerritoryTypeComponent,
        FsmTerritoryActionComponent,
        GlobalSearchComponent,
        SavedSearchComponent,
        DuplicateCheckComponent,
        SharedEmailToModuleRecordComponent,
        CrmSharedConfigurationComponent,
        CrmSharedChannelComponent,
        CrmSharedTemplateComponent,
        TermsConditionsComponent,
        SignatureComponent,
        RoleHierarchyComponent,
        ProfileComponent,
        GuideComponent,
        VisibilityGroupComponent,
        SeriesComponent,
        ActivityComponent,
        ISettingComponent,
        CSettingComponent,
        FSettingComponent,
        TemplateTableComponent,
        EmailTemplateComponent,
        PrintTemplateComponent,
        AddPhoneComponent,
        RegistrationComponent,
        ResetPasswordComponent,
        AdditionlfeesComponent,
        PosComponent,
        SerialDetailsComponent,
        ConfigurationWorkspaceComponent,
        WorkspaceCommentCategoryComponent,
        AddUpdateCommentCategoryComponent,
    ],
    providers: [
        CustomLoggerService,
        EmailService,
        // {
        //     provide: ErrorHandler,
        //     useValue: Sentry.createErrorHandler({
        //         logErrors: environment.enableLogger,
        //         showDialog: false
        //     }),
        // }, {
        //     provide: Sentry.TraceService,
        //     deps: [Router],
        // },
        {
            provide: APP_INITIALIZER,
            useFactory: () => () => { },
            deps: [Sentry.TraceService],
            multi: true,
        },
        { provide: APP_INITIALIZER, useFactory: appInitializerFactory, multi: true },
        { provide: LocationStrategy, useClass: PathLocationStrategy },
        { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
        provideCharts(withDefaultRegisterables()),
        MenuService, UserService, LeadService, OpportunityService,
        ConfirmationService, MessageService, ContactService, TerriService, GoalsService, AccountService, ActivityService,
        CasesService,
        ConfigurationService,
        CompanyBranchService,
        ImportService,
        AppMainService,
        ObjectCalendarEventService,
        LocationService,
        TypeService,
        LogService,
        NoteService,
        PdfService,
        ObjectLogService,
        ObjectNoteService,
        VendorOAuthRegistrationUserService,
        CategoryService,
        VendorOAuthRegistrationService,
        VendorService,
        ObjectEmailAuditService,
        ObjectTaskService,
        RepeatTypeService,
        GroupService,
        SharedTypeService,
        TaskCategoryService,
        CalendarEventService,
        EmailAuditService,
        RecipientTypeService,
        DatePipe,
        TitleCasePipe,
        DecimalPipe,
        TaskService,
        ReportService,
        contactService,
        AccountUserService,
        QuotationService,
        SalesOrderService,
        ProductsService,
        FinanceService,
        ReportTableService,
        FinanceModulePermissionService,
        QuestionnaireService,
        NotificationService,
        PermissionService,
        ProfileService,
        SharedSystemActivitiesService,
        OpportunitiesGuardService,
        GoalGuardService,
        GlobalFilter,
        AddYearPipe,
        // {
        //     provide: TRANSLOCO_CONFIG,
        //     useValue: {
        //         reRenderOnLangChange: true,
        //         availableLangs: ['en', 'fr', 'zh'],
        //         prodMode: true,
        //         defaultLang: 'en',
        //         fallbackLang: 'en'
        //     }
        // },
        SharedContactService,
        CurrencyService,
        DashboardDataService,
        CookieService

    ],
    bootstrap: [AppComponent],
    schemas: [NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }
